import { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { Button } from '@follow/ui';

interface ModalOpenAllLocksProps {
  visible: boolean;
  lockCount: number;
  onCancel: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
}

const ModalOpenAllLocks: React.FC<ModalOpenAllLocksProps> = ({
  visible,
  lockCount,
  onCancel,
  onConfirm,
  isLoading,
}) => (
  <Transition.Root show={visible} as={Fragment}>
    <Dialog as="div" className="relative z-50" onClose={onCancel}>
      <Transition.Child
        as={Fragment}
        enter="ease-out duration-300"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="ease-in duration-200"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <div className="fixed inset-0 bg-neutral-30 transition-opacity" />
      </Transition.Child>

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-center justify-center p-4">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-lg bg-white p-6 shadow-card outline outline-1 outline-offset-[-1px] outline-neutral-10 transition-all">
              <div className="flex items-start gap-4">
                <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg bg-amber-100">
                  <ExclamationTriangleIcon className="h-5 w-5 text-amber-600" />
                </div>
                <div className="flex flex-col gap-1">
                  <Dialog.Title as="h3" className="text-neutral typo-label">
                    Ouvrir tous les locks ?
                  </Dialog.Title>
                  <p className="text-neutral-80 typo-small">
                    Cette action va ouvrir les <strong>{lockCount}</strong> locks actifs immédiatement.
                  </p>
                </div>
              </div>
              <div className="mt-6 flex justify-end gap-2">
                <Button variant="outline" size="sm" onClick={onCancel}>
                  Annuler
                </Button>
                <Button
                  variant="primary"
                  size="sm"
                  onClick={onConfirm}
                  disabled={isLoading}
                >
                  {isLoading ? 'Ouverture...' : 'Confirmer'}
                </Button>
              </div>
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </div>
    </Dialog>
  </Transition.Root>
);

export default ModalOpenAllLocks;
